import React from 'react';

// NOTE: v1 placeholder artwork. Designer pass pending.
export default function BonfireAccessory() {
  return (
    <g aria-hidden="true">
      {/* Trail rising from below (rocket trail) */}
      <path d="M100,90 Q98,75 100,60" stroke="#E5B941" strokeWidth="2" strokeLinecap="round" strokeDasharray="3,3" fill="none" opacity="0.7" />
      {/* Bright centre */}
      <circle cx="100" cy="50" r="5" fill="#E5B941" />
      <circle cx="100" cy="50" r="3" fill="#F9FCF1" />
      {/* Radiating sparks */}
      <g strokeLinecap="round">
        <line x1="100" y1="50" x2="100" y2="20" stroke="#E5B941" strokeWidth="2.5" />
        <line x1="100" y1="50" x2="115" y2="24" stroke="#E0290A" strokeWidth="2.5" />
        <line x1="100" y1="50" x2="130" y2="50" stroke="#E89A2E" strokeWidth="2.5" />
        <line x1="100" y1="50" x2="121" y2="71" stroke="#E5B941" strokeWidth="2.5" />
        <line x1="100" y1="50" x2="85" y2="24" stroke="#E0290A" strokeWidth="2.5" />
        <line x1="100" y1="50" x2="70" y2="50" stroke="#E89A2E" strokeWidth="2.5" />
        <line x1="100" y1="50" x2="79" y2="71" stroke="#E5B941" strokeWidth="2.5" />
        <line x1="100" y1="50" x2="124" y2="34" stroke="#E89A2E" strokeWidth="2" />
        <line x1="100" y1="50" x2="76" y2="34" stroke="#E89A2E" strokeWidth="2" />
        <line x1="100" y1="50" x2="124" y2="66" stroke="#E0290A" strokeWidth="2" />
        <line x1="100" y1="50" x2="76" y2="66" stroke="#E0290A" strokeWidth="2" />
      </g>
      {/* Star tips on the long rays */}
      <g fill="#E5B941">
        <path d="M100,15 L101,19 L105,19 L102,22 L103,26 L100,24 L97,26 L98,22 L95,19 L99,19 Z" />
        <path d="M135,50 L136,46 L132,49 L128,47 L130,51 L128,55 L132,53 L136,56 L135,52 L139,50 Z" transform="translate(-5 0)" />
        <path d="M65,50 L66,46 L62,49 L58,47 L60,51 L58,55 L62,53 L66,56 L65,52 L69,50 Z" transform="translate(5 0)" />
      </g>
      {/* Spark dots at the end of the shorter rays */}
      <circle cx="115" cy="24" r="2" fill="#E0290A" />
      <circle cx="85" cy="24" r="2" fill="#E0290A" />
      <circle cx="121" cy="71" r="2" fill="#E5B941" />
      <circle cx="79" cy="71" r="2" fill="#E5B941" />
      <circle cx="124" cy="34" r="1.8" fill="#E89A2E" />
      <circle cx="76" cy="34" r="1.8" fill="#E89A2E" />
      <circle cx="124" cy="66" r="1.8" fill="#E0290A" />
      <circle cx="76" cy="66" r="1.8" fill="#E0290A" />
    </g>
  );
}
